/*
  請瀏覽器／手機的密碼管理員記住帳號密碼（2026-10-20）。

  為什麼不自己存：網站能存東西的地方（localStorage、Cookie）都是明文，這個網域上任何一段程式
  （包含 GTM、GA 這類第三方腳本，或被植入的惡意程式）、瀏覽器擴充功能、共用電腦的下一個人都讀得到。
  密碼管理員（Chrome／Edge／Android 的 Google 密碼管理工具、Safari 的 iCloud 鑰匙圈）會加密保存，
  拿出來用要先解鎖電腦或手機，換手機也會跟著帳號同步。

  兩層：
    1. 登入、設定密碼的欄位標好 autocomplete（username／current-password／new-password），
       所有密碼管理員都靠這個認出「這是登入表單」並自動填入
    2. 登入成功後呼叫 Credential Management API，主動請瀏覽器跳出「要儲存密碼嗎？」——
       我們的登入是 API 呼叫、不是傳統表單送出，有些瀏覽器自己判斷不到。
       只有 Chrome 系（含 Edge、Android Chrome）支援；Safari、App 內的網頁視窗沒有這個 API，就只靠第 1 層

  使用者可以在瀏覽器的提示按「不要」，存不存是他的選擇；這裡失敗一律安靜略過。
*/
export function canStorePasswordCredential() {
  return typeof window !== "undefined" && typeof window.PasswordCredential === "function" && !!(navigator.credentials && navigator.credentials.store);
}

export async function savePasswordCredential(email, password, name) {
  if (!email || !password || !canStorePasswordCredential()) return false;
  try {
    const credential = new window.PasswordCredential({ id: email, password, name: name || email });
    await navigator.credentials.store(credential);
    return true;
  } catch (e) {
    return false;
  }
}
